import { Station, Timetable } from 'thunks/times2Api';

export const DATA_FILES_LOADED = 'DATA_FILES_LOADED';
export const LOADED_VALID_TOCS = 'LOADED_VALID_TOCS';
export const STATIONS_LOADED = 'STATIONS_LOADED';

const dateWithinHours = (date, hours) => {
  const past = date * 1;
  const now = (new Date() * 1);
  return (now - past) < (hours * 3600 * 1000);
};

const dateIsToday = (date) => {
  const now = new Date();
  return date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
};

export const loadValidStations = () => (dispatch, getState) => {
  // If we've got stations from within 24 hours, don't load them again
  const state = getState().reference;
  if (state.stations.length && dateWithinHours(state.lastUpdated.stations, 24)) {
    return Promise.resolve();
  }

  // Load the most-up-date station list
  const stations = new Station();
  return stations.list(getState().auth.user.token)
    .then(result => dispatch({
      type: STATIONS_LOADED,
      payload: result.data,
    }));
};

export const loadDataFiles = () => (dispatch, getState) => {
  // If we've got data files from within 24 hours, don't load them again
  const state = getState().reference;
  if (state.dataFiles.length && state.lastUpdated.dataFiles !== null && dateIsToday(state.lastUpdated.dataFiles)) {
    return Promise.resolve();
  }

  // Load the data files
  const timetable = new Timetable();
  return timetable.dataList(getState().auth.user.token)
    .then((result) => {
      dispatch({
        type: DATA_FILES_LOADED,
        payload: result.data,
      });
    });
};

export const loadValidTOCS = () => (dispatch, getState) => {
  // If we've got tocs from within 48 hours, don't load them again
  const state = getState().reference;
  if (Object.keys(state.tocs).length && dateWithinHours(state.lastUpdated.tocs, 48)) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const station = new Station();
    dispatch({
      type: LOADED_VALID_TOCS,
      payload: station.tocs,
    });
    resolve();
  });
};

const INITIAL_STATE = {
  dataFiles: [{ id: 0, name: 'Loading', curr_ref: '...' }],
  tocs: [],
  stations: [],
  lastUpdated: {
    dataFiles: null,
    tocs: null,
    stations: null,
  },
};

export default function fileReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DATA_FILES_LOADED:
      return {
        ...state,
        dataFiles: action.payload,
        lastUpdated: { ...state.lastUpdated, dataFiles: new Date() },
      };
    case LOADED_VALID_TOCS:
      return {
        ...state,
        tocs: action.payload,
        lastUpdated: { ...state.lastUpdated, tocs: new Date() },
      };
    case STATIONS_LOADED:
      return {
        ...state,
        stations: action.payload,
        lastUpdated: { ...state.lastUpdated, stations: new Date() },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reference.js